import React, { useState } from 'react';
import Modal from 'components/Layout/Modal';
import Button from 'components/form/Button';
import { useDispatch } from 'react-redux';
import { handleCallhippoCall, showSuccess } from 'store/slices';

const CallConnectPopup = ({ onHide, data }) => {
  const [isCallLoader, setIsCallLoader] = useState(false);
  const dispatch = useDispatch();
  const callHippoApiCall = async (isCallConnect) => {
    setIsCallLoader(true);
    const phone_no = `${isCallConnect?.user_country_code || ''}${
      isCallConnect?.user_mobile_no || isCallConnect?.phone
    }`.trim();

    const payload = {
      phone_no: phone_no,
      user_id: data.user_id || data.id,
    };
    const response = await dispatch(handleCallhippoCall(payload));
    if (response?.status === 200) {
      dispatch(showSuccess('Call Connected'));

      onHide();
      setIsCallLoader(false);
    }
    setIsCallLoader(false);
  };

  return (
    <Modal
      onHide={onHide}
      size="md"
      titleBesideClose={'Are you sure want to connect call?'}
      isTitleVerticalCenter
      titleBesideCloseClassName={'text-16-300-20'}
    >
      <div className="d-flex align-items-start cpt-23 cps-10 gap-2">
        <Button
          text="Yes, Connect"
          btnStyle="primary-dark"
          className="h-35 text-14-500 text-nowrap w-auto px-3 ms-auto"
          onClick={() => callHippoApiCall(data)}
          btnLoading={isCallLoader}
          disabled={isCallLoader}
        />
        <Button
          text="Cancel"
          btnStyle="light-outline"
          className="h-35 text-14-500 text-nowrap w-auto px-3"
          type="button"
          onClick={onHide}
        />
      </div>
    </Modal>
  );
};

export default CallConnectPopup;
